import { render, staticRenderFns } from "./emailReports.vue?vue&type=template&id=056f0728&scoped=true&"
import script from "./emailReports.vue?vue&type=script&lang=js&"
export * from "./emailReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f0728",
  null
  
)

export default component.exports